import React from 'react';
import styled from 'styled-components';
import { ChannelSubHeader } from 'components/atoms/header/ChannelHeader';
import DividerLine from 'components/atoms/DividerLine';
import RenderingTile from 'components/molecules/RenderingTile';
import { NoDataTile } from 'components/molecules/ErrorTile';

const DividerLineStyled = styled(DividerLine)`
    margin-bottom: 32px;
`;

/**
 * Dashboard submodule with loading conditionals, divider line and header title
 *
 * @param {object} params
 * @param {string} params.title Module Header title used at top of module and when no data is rendered
 * @param {boolean|null|string} params.hasData Flag used to control the rendering state of the module
 * @param {components} params.children React components passed to the Module
 * @returns {null|React.Fragment}
 * @constructor
 */
const SubModule = ({ title, hasData, children }) => {
    switch (hasData) {
    case null:
        return (
            <React.Fragment>
                <DividerLineStyled />
                <ChannelSubHeader>{title}</ChannelSubHeader>
                <RenderingTile height='400px' show={hasData} />
            </React.Fragment>
        );
    case 'HIDE_SECTION':
        return null;
    case true:
        return (
            <React.Fragment>
                <DividerLineStyled />
                <ChannelSubHeader>{title}</ChannelSubHeader>
                {children}
            </React.Fragment>
        );
    case false:
    default:
        return (
            <React.Fragment>
                <DividerLineStyled />
                <ChannelSubHeader>{title}</ChannelSubHeader>
                <NoDataTile title={title} />
            </React.Fragment>
        );
    }
};

export default SubModule;



// WEBPACK FOOTER //
// ./src/components/organisms/SubModule.js